import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { ApConfig } from 'src/app/classes/models';
import { ApConfigService } from 'src/app/services/ap-config.service';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-ap-configs-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './ap-configs-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ApConfigsGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private ApConfigService: ApConfigService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'ApConfig';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.ApConfigService.getApConfigs(queryObject),
          this.ApConfigService.getApConfigCount(countQueryObject)
        ]).subscribe({
          next: ([ApConfigs, apConfigCount]: [ApConfig[], number]) => {
            params.success({
              rowData: ApConfigs,
              rowCount: apConfigCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
